import { keyframes } from '@mui/material/styles';

/**
 * The motion every surface shares: one easing curve, short durations, and entrances that move a
 * few pixels. `prefers-reduced-motion` switches all of it off in the theme's baseline styles.
 */
export const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const rise = keyframes({
  from: { opacity: 0, transform: 'translateY(14px)' },
  to: { opacity: 1, transform: 'none' },
});

export const pop = keyframes({
  from: { opacity: 0, transform: 'scale(0.96)' },
  to: { opacity: 1, transform: 'none' },
});

export const drift = keyframes({
  from: { transform: 'translate3d(0, 0, 0) scale(1)' },
  to: { transform: 'translate3d(24px, 16px, 0) scale(1.12)' },
});

export const sheen = keyframes({
  from: { backgroundPosition: '0% 50%' },
  to: { backgroundPosition: '100% 50%' },
});

/** The activity line under the header crossing from left to right. */
export const sweep = keyframes({
  from: { transform: 'translateX(-100%)' },
  to: { transform: 'translateX(250%)' },
});

/** A card that lifts under the pointer. */
export const lift = {
  transition: `transform 220ms ${EASE}, box-shadow 220ms ${EASE}`,
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 18px 30px -12px rgba(47, 49, 54, 0.18), 0 6px 10px -6px rgba(47, 49, 54, 0.10)',
    borderColor: 'rgba(108, 203, 154, 0.4)',
  },
} as const;
